module.exports = __webpack_public_path__ + "static/media/more.dd9b736c.svg";